import L from 'leaflet';

// icon
import circleRed from '../../../assets/map/marker/circle/red.png';
import circleBlue from '../../../assets/map/marker/circle/blue.png';
import circleGreen from '../../../assets/map/marker/circle/green.png';
import circleYellow from '../../../assets/map/marker/circle/yellow.png';
import circleGrey from '../../../assets/map/marker/circle/grey.png';
import circleCrimson from '../../../assets/map/marker/circle/crimson.png';
import circleGold from '../../../assets/map/marker/circle/gold.png';

const iconCircleCrimson = new L.Icon({
  iconUrl: circleCrimson,
  iconSize: [8, 8],
});

const iconCircleRed = new L.Icon({
  iconUrl: circleRed,
  iconSize: [8, 8],
});

const iconCircleBlue = new L.Icon({
  iconUrl: circleBlue,
  iconSize: [10, 10],
});

const iconCircleGreen = new L.Icon({
  iconUrl: circleGreen,
  iconSize: [8, 8],
});

const iconCircleYellow = new L.Icon({
  iconUrl: circleYellow,
  iconSize: [8, 8],
});

const iconCircleGrey = new L.Icon({
  iconUrl: circleGrey,
  iconSize: [8, 8],
});

const iconCircleGold = new L.Icon({
  iconUrl: circleGold,
  iconSize: [8, 8],
});

const iconCircle = {
  crimson: iconCircleCrimson,
  red: iconCircleRed,
  blue: iconCircleBlue,
  green: iconCircleGreen,
  yellow: iconCircleYellow,
  grey: iconCircleGrey,
  gold: iconCircleGold,
};

export default iconCircle;
